var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoutOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#494d7d",
    stroke: "#d6d7e2",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 58,
    height: 58,
    rx: 29,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M378.968,381a2.993,2.993,0,0,1-2.987-3V362a2.993,2.993,0,0,1,2.987-3h4.978a1,1,0,0,1,0,2h-4.978a1,1,0,0,0-1,1v16a1,1,0,0,0,1,1h4.978a1,1,0,0,1,0,2Zm11.243-6.293a1,1,0,0,1,0-1.414L392.494,371h-9.543a1,1,0,0,1,0-2h9.543l-2.283-2.293a1,1,0,1,1,1.409-1.414l3.982,4a1,1,0,0,1,.182.251v0l.009.019,0,0,.008.016,0,.008.006.013,0,.012,0,.01.006.014,0,.007.006.017,0,0,.007.02v0a1,1,0,0,1,.038.164h0l0,.023v0l0,.021v.005l0,.019v.009c0,.005,0,.01,0,.015s0,.009,0,.013,0,.008,0,.011,0,.017,0,.025,0,.017,0,.025,0,.007,0,.011,0,.009,0,.013,0,.01,0,.015v.009l0,.019v.005l0,.021v0l0,.023h0a1,1,0,0,1-.031.141h0l-.007.022v0l-.007.02,0,0-.006.017,0,.007-.006.014,0,.01,0,.012-.006.013,0,.008-.007.016,0,0-.009.019v0l-.011.021h0a1,1,0,0,1-.171.231l-3.982,4a.993.993,0,0,1-1.409,0Z",
    transform: "translate(-355 -341)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutOn);
export default __webpack_public_path__ + "static/media/logout-on.c1dfaed7e71b888a03e5675ecfdb8ade.svg";
export { ForwardRef as ReactComponent };